import Vue from "vue"

/**
 * Start new evaluate session
 * @param {*} data 
 * @returns {Promise} js promise object
 */
const initSession = function (data) {
    return Vue.axios.post("/evaluate/init", data)
}

/**
 * Start new evaluate session
 * @param {*} data 
 * @returns {Promise} js promise object
 */
const newSession = function (data) {
    return Vue.axios.post("/evaluate/session", data)
}

/**
 * Save user answer
 * @param {*} data 
 * @returns {Promise} js promise object
 */
const saveAnswer = function (id, data) {
    return Vue.axios.post(`/evaluate/${id}/state`, data)
}

/**
 * get current section
 * @param {*} sessionId 
 * @returns {Promise} js promise object
 */
const getSection = function (sessionId) {
    return Vue.axios.get(`/evaluate/${sessionId}/section`)
}

/**
 * get next section
 * @param {*} sessionId 
 * @returns {Promise} js promise object
 */
const nextSection = function (sessionId) {
    return Vue.axios.get(`/evaluate/${sessionId}/section/next`)
}

/**
 * get previous section
 * @param {*} sessionId 
 * @returns {Promise} js promise object
 */
const prevSection = function (sessionId) {
    return Vue.axios.get(`/evaluate/${sessionId}/section/prev`)
}

/**
 * finish session
 * @param {*} sessionId 
 * @returns {Promise} js promise object
 */
const finishSession = function (sessionId) {
    return Vue.axios.post(`/evaluate/${sessionId}/finish`, {})
}


export default { initSession, newSession, getSection, nextSection, prevSection, saveAnswer, finishSession }